/** The demo project the guided tours are built on: its agents, reports and queues are what they open. */
export const DEMO_PROJECT = {
    slug: 'credit_card_classification',
    name: 'Credit Card Classification',
} as const;
